import { HashMap } from '../../constants';
import { Loadable } from '../../models';
import { PageParameters } from '../../models/account';

/** The number of seconds the application will wait before refreshing the user roles from the server. */
export const UserRolesCacheTimeout = 3600;

/**
 * Interface which encapsulates the user's roles.
 */
export interface UserRoles extends PageParameters {
  all: string[];
  byId: HashMap<boolean>;
}

export const getDefaultUserRolesState = (): Loadable<UserRoles> => {
  return {
    companyId: 0,
    isLoading: false,
    byId: {},
    all: [],
  };
};
